import { cx } from "class-variance-authority";
import IcClose from "~/images/ic_navigation_close.svg";
import { typography } from "~/styles/typographies";
import styles from "./BottomSheet.module.css";

export interface BottomSheetProps {
  children: React.ReactNode;
  onClose: () => void;
  smallTitle: string;
  largeTitle: string;
  description?: string;
}

export function BottomSheet({
  children,
  smallTitle,
  largeTitle,
  description,
  onClose,
}: BottomSheetProps) {
  return (
    <div className={styles.container} data-ignorefocus="true">
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.bottomSheet}>
        <div className={styles.header}>
          <div>
            <h2
              className={cx(
                typography({ fontSize: "h5", fontWeight: "bold" }),
                styles.smallTitle,
              )}
            >
              {smallTitle}
            </h2>
            <h2
              className={cx(
                typography({ fontSize: "h5", fontWeight: "bold" }),
                styles.largeTitle,
              )}
            >
              {largeTitle}
            </h2>
            {description ? (
              <p
                className={typography({
                  fontSize: "body3",
                  fontWeight: "regular",
                })}
              >
                {description}
              </p>
            ) : null}
          </div>
          <button type="button" onClick={onClose}>
            <img alt="close" src={IcClose} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
